module.exports = __webpack_public_path__ + "img/qr-code.f71b201a.png";